// API response handler
export const handleApiResponse = (response) => {
  if (!response.data) {
    throw new Error('Invalid response from server');
  }
  return response.data;
};

// API error handler
export const handleApiError = (error) => {
  return {
    success: false,
    message: error.response?.data?.message || 'Something went wrong',
    status: error.response?.status || 500,
    error: error,
  };
};
